module.exports = __webpack_public_path__ + "images/iphone/back_button.png";